module.exports = __webpack_public_path__ + "img/cases04-bg.2df9e6dc.png";